import { useEffect } from 'react';
import { Grid, Modal, TextField } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  ModalCancelButton,
  ModalSubmitButton
} from '../parts/cloudStorage/style/style';
import { useForm, SubmitHandler } from 'react-hook-form';

type Inputs = {
  name: string;
};

type Tprops = {
  selectItem: any;
  detailItemFlg: boolean;
  createModal: boolean;
  setCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
  createItem: any;
};

export const CreateModal: React.FC<Tprops> = (props: Tprops) => {
  const { selectItem, detailItemFlg, createModal, setCreateModal, createItem } =
    props;

  const classes = useStyles();

  // react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = data => {
    createItem(detailItemFlg, data.name, selectItem.id);
    setCreateModal(false);
  };

  // モーダルの開閉時に入力欄をリセット
  useEffect(() => {
    reset({
      name: ''
    });
  }, [createModal]);

  return (
    <Modal
      open={createModal}
      onClose={() => setCreateModal(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12} className={classes.modalHeader}>
              <div style={{ textAlign: 'center', padding: 40 }}>
                {detailItemFlg ? (
                  <p style={{ fontSize: 18 }}>
                    「{selectItem.name}」の小項目を追加
                  </p>
                ) : (
                  <p style={{ fontSize: 18 }}>大項目を追加</p>
                )}
              </div>
              <div className={classes.inputArea}>
                <div className={classes.formlabel}>
                  <div style={{ marginRight: 36 }}>項目名</div>
                  <div style={{ width: '70%' }}>
                    <TextField
                      variant='outlined'
                      id='outlined-error-helper-text'
                      placeholder={'20文字以内で入力'}
                      style={{ width: '100%', marginBottom: 30 }}
                      {...register('name', {
                        required: '入力必須です。',
                        maxLength: {
                          value: 20,
                          message: '20文字以内で入力してください。'
                        }
                      })}
                      error={'name' in errors}
                      helperText={errors.name?.message}
                    />
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.modalFooter}>
              <ModalCancelButton
                variant='contained'
                onClick={() => {
                  setCreateModal(false);
                }}
              >
                キャンセル
              </ModalCancelButton>
              <ModalSubmitButton variant='contained' type='submit'>
                作成
              </ModalSubmitButton>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Modal>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '70%',
      overflow: 'hidden'
    },
    subpaper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '40%'
    },
    inputArea: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    },
    formlabel: {
      width: '80%',
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'center'
    },
    modalFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    }
  })
);
